import * as React from 'react';
import PropTypes from 'prop-types';

import Toolbar from 'material-ui/Toolbar';
import { withStyles } from 'material-ui';
import { lighten } from 'material-ui/styles/colorManipulator';

const style = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    backgroundColor: lighten(theme.palette.primary.light, 0.85),
    minWidth: 700,
  },
  title: {
    flex: '0 0 auto',
    width: '100%'
  }
})

export const TableToolbar = props => {
  const { children, classes } = props;

  return (
    <Toolbar className={classes.root}>
      <div className={classes.title}>
        {children}
      </div>
    </Toolbar>
  )
}

TableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(style)(TableToolbar);


// WEBPACK FOOTER //
// ./src/components/common/TableToolbar.js